module.exports = __webpack_public_path__ + "media/images/icon-20419284b6569f936a9a451a0dbde4c2.png";